module.exports = __webpack_public_path__ + "static/media/tiktok.acf6a5be.svg";